var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('LMap',{ref:"myMap",attrs:{"center":_vm.center,"zoom":_vm.zoom},on:{"ready":_vm.handleReady}},[(_vm.isReady)?_vm._t("default"):_vm._e(),_c('l-tile-layer',{attrs:{"url":_vm.url,"attribution":_vm.attribution}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }